export const environment = {
  production: false,
  BASE_API_URL: 'https://locaviaweb.com.br/carsubs/api',
  encryptSecretKey:
    'JNQg$HPvP_,?!1Oe<rQ5D5i}iy:n)@INFO`Qv<E_$.]BL5HJdR-BI22}yn5p)z9_ao?7',
};
